module.exports = __webpack_public_path__ + "img/Asset 1@2x.98000f8b.png";